import { cn } from 'cn';

import { GetProjectQuery } from '@/survey-graphql';

import SurveyAiQuestionAssetItem from './survey-ai-forms-ai-question-asset-item';

type ProjectQuestion = NonNullable<
  GetProjectQuery['project']
>['questions'][number];

interface Props {
  text: string;
  assets: ProjectQuestion['assets'];
}

export default function SurveyAiFormsAiSectionQuestionTitle({
  text,
  assets,
}: Props) {
  return (
    <div data-test='question-title-wrapper' className='flex flex-col gap-4'>
      {assets && assets.length > 0 && (
        <SurveyAiQuestionAssetItem
          key={assets[0].id}
          name={assets[0].name ?? ''}
          url={assets[0].url ?? ''}
        />
      )}

      {/* Question Title */}
      <h2
        data-test='question-title-text'
        className={cn(
          'text-(--brand-secondary)',
          '[font-family:var(--brand-font)] text-xl/7.5 font-semibold md:text-[28px]/10.5'
        )}
      >
        {text}
      </h2>
    </div>
  );
}
